import { MeasuredCookieConnector } from '../../../Measured';
import MeasuredStageComponent from './MeasuredStage';
var MeasuredStage = MeasuredCookieConnector(MeasuredStageComponent);
export default MeasuredStage;
//# sourceMappingURL=index.js.map